import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Badge from "../../components/badges/Badges";
import Button from "../../components/button/Button";
import { Spiner } from "../../components/spinner/Spiner";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { auth } from "../../firebase";
import companiesQuery from "../../firestore/Companies.query";
import userQuery from "../../firestore/User.query";
import { Company } from "../../model/Companies";
import { Groups } from "../../model/Groups";
import { ColorList, GroupsSetting, UserData, UserItemMaping, APP_USE, GetAppUseStateFromUserData } from "../../model/Users";
import { UserListSearch } from "./UserListSearch";
import { SearchKeys } from "../../model/SearchKeys";
import { requestGetUser } from "../../api/Users.api";

export const UserList = () => {
  const initialUserList: UserData[] = [];
  const [userList, setUserList] = useState(initialUserList);
  const [searchUserList, setSearchUserList] = useState<UserData[]>([]);
  const [searchUserListFlg, setSearchUserListFlg] = useState(false);
  const [groupList, setGroupList] = useState<Groups[]>([]);
  const [isLode, setIsLode] = useState(true);
  const [company, setCompany] = useState<Company>();
  const [activeUsers, setActiveUsers] = useState<string[]>([]);
  const navigation = useNavigate();
  const [allUserCnt, setAllUserCnt] = useState(0);
  const [appAvailableUserCnt, setAppAvailableUserCnt] = useState(0);
  const [AppUnavailableUserCnt, setAppUnavailableUserCnt] = useState(0);
  const [nowPage, setNowPage] = useState(1);
  const [selectNumber, setSelectNumber] = useState(50);
  const [userCount, setUserCount] = useState(0);
  const [adminUserCount, setAdminUserCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [searchKeyList, setSearchKeyList] = useState<SearchKeys[]>();
  const [searchKey1List, setSearchKey1List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [searchKey2List, setSearchKey2List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [searchKey3List, setSearchKey3List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [firstPageFlg, setFirstPageFlg] = useState(false);
  const [isUpdateSearchKeys, setIsUpdateSearchKeys] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [searchCondition, setSearchCondition] = useState<any>({}); // 検索条件のstateを定義
  const [companyGroupNames, setCompanyGroupNames] = useState<string[]>([]);

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  useEffect(() => {
    let ignore = false;

    const f = async () => {
      if(!ignore) {
        if(currentUser?.tenantId !== null || currentUser?.tenantId !== undefined ){
          // 団体のdisplayIdを取得
          const companyData = await companiesQuery.getCompany(currentUser?.tenantId!);
          setCompany(companyData);
          // 利用者総件数取得
          const userAllCnt = await userQuery.getUserListLength(currentUser?.tenantId!);
          setAllUserCnt(userAllCnt);
          // アプリ利用可能件数取得
          const appAvailable = await userQuery.getAppAvailableLength(currentUser?.tenantId!);
          setAppAvailableUserCnt(appAvailable);
          // アプリ利用不可件数取得
          const appUnavailable = await userQuery.getAppUnavailableLength(currentUser?.tenantId!);
          setAppUnavailableUserCnt(appUnavailable);
          // 団体グループ取得
          const companyGroups = await companiesQuery.getGroups(companyData.id);
          // グループ選択モーダル用リストを作成
          const filteredGroups = companyGroups.filter((group) => group.deleteFlg === false)
          setGroupList(filteredGroups);
          // 検索キー1,2,3取得
          const searchKeys = await companiesQuery.getSearchKeys(companyData.id);
          setSearchKeyList(searchKeys);
          if (searchKeys.length > 0) {
            searchKeys.map((item) => {
              const keyValues = item.keyValues;
              if (keyValues.length > 0) {
                keyValues.sort((a, b) => a.sort - b.sort);
                const searchKeyList = [...keyValues].map(obj => ({
                  value: obj.searchName,
                  disabled: false
                }));
                if (item.name === "userSearchKey1") {
                  const searchKey1SelectList = [...searchKeyList];
                  setSearchKey1List(searchKey1SelectList);
                } else if (item.name === "userSearchKey2") {
                  const searchKey2SelectList = [...searchKeyList];
                  setSearchKey2List(searchKey2SelectList);
                } else if (item.name === "userSearchKey3") {
                  const searchKey3SelectList = [...searchKeyList];
                  setSearchKey3List(searchKey3SelectList);
                }
              }
            })
          } else {
            const emptyValue = [{value: '', disabled: false}];
            setSearchKey1List(emptyValue);
            setSearchKey2List(emptyValue);
            setSearchKey3List(emptyValue);
          }
        }
      }
      await getMessage();
    };
    f();

    return () => {
      ignore = true;
    }
  },[currentUser?.tenantId, nowPage]);

  // ユーザー一覧を取得する共通処理
  useEffect(() => {
    const fetchUsersByPage = async () => {
      const result = await requestGetUser(
        nowPage,
        selectNumber,
        searchCondition
      );
      if (result.success) {
        setUserList(result.users);
        setTotalCount(result.totalCount);
      } else {
        console.error("ユーザー取得失敗:", result.error);
      }
      setIsLode(false)
    };
    fetchUsersByPage();
  }, [nowPage, selectNumber, searchCondition]);

  // 検索ボタンが押されたときの処理
  const handleSearch = (condition: any) => {
    setIsLode(true);
    setSearchCondition(condition);
    setNowPage(1); // 検索時は常に1ページ目に戻す
  };

  // ページング処理
  const pagingFunc = useCallback((page: number) => {
    setSearchUserListFlg(false);
    setFirstPageFlg(false);
    setNowPage(page);
  }, []);

  const columns: GridCol[] = [
    {
      field: "loginState",
      headerName: "ログイン",
      style: "w-1/12",
      sort: false
    },
    {
      field: "id",
      headerName: "利用者番号",
      style: "",
      sort: false
    },
    {
      field: "name",
      headerName: "名前",
      style: "w-1/6",
      sort: false
    },
    {
      field: "groups",
      headerName: "所属グループ",
      style: "w-1/4",
      sort: false
    },
    {
      field: "deleteFlg",
      headerName: "アプリ利用",
      style: "w-1/12",
      sort: false
    },
    {
      field: "admin",
      headerName: "役割",
      style: "w-1/12",
      sort: false
    },
    {
      field: "info",
      headerName: "詳細",
      style: "",
      sort: false
    },
  ];

  const rowList: GridRow[] = (searchUserListFlg ? searchUserList : userList).map<GridRow>((item) => {
    let age: number | undefined = undefined;
    //TODO Del const birthDate = Number.isNaN(item?.birthDate?.getTime()) ? undefined : item?.birthDate;
    //TODO Add Start
    const birthDate = item?.birthDate ? new Date(item.birthDate) : undefined;
    //TODO Add End
    if(birthDate !== undefined){
      const today = new Date();
      const thisYearsBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
      age = today.getFullYear() - birthDate.getFullYear();
      if(today < thisYearsBirthday){
        age--;
      }
    }
    const ageString = (typeof age === 'number' && !Number.isNaN(age)) ? `(${age}歳)` : '';
    const name = `${item.lastName !== undefined && item.lastName !== '' ? item.lastName : ''} ${ageString}`
    const deleteFlg = GetAppUseStateFromUserData(item);
    return {
      rowData: {
       loginState: (
          <>
            {deleteFlg === APP_USE.SUSPEND
              ? (<Badge color="yellow">未</Badge>)
              : !item.loginDone
                ? (<Badge color="yellow">未</Badge>)
                : (<Badge color="green">済</Badge>)}
          </>
        ),
        id: item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId.length ?? 0)),
        name: (<div className={"whitespace-nowrap"}>{name}</div>),
        groups: (<>
          {[...new Map(
            item.groups
              .filter((group) => !group.disabled)
              .map(group => [group.id, group])
          ).values()]
            .sort((a, b) => (a.id < b.id ? 1 : -1))
            .map((group, index) => (
              <Badge
                key={`${group.id}-${index}-${item.id}`}
                color={group.color}
                className={group.disabled ? "opacity-30" : ""}>
                {group.name}
              </Badge>
            ))}
        </>),
        deleteFlg: (<>{deleteFlg === APP_USE.SUSPEND
          ? (<Badge color="gray">停止</Badge>) : (deleteFlg === undefined)
          ? (<></>) : deleteFlg === APP_USE.UNUSEABLE
          ? (<Badge color="red">不可</Badge>) : (<Badge color="green">利用可</Badge>)}</>),
        admin: (<>{(item.admin === undefined)
          ? (<></>) : item.admin
          ? (<Badge color="red">運営者</Badge>) : (<Badge className={"whitespace-nowrap"} color="indigo">利用者</Badge>)}</>),
        info: (<Button className={"sm:px-4 whitespace-nowrap"} onClick={()=> navigation(`${item.id}/info`)}>詳細</Button>),
      },
      sortableRowData: {
        loginState: activeUsers.includes(item.id) ?? false,
        name: item.lastNameKana ?? '',
        groups: item.groups
          .filter((group) => !group.disabled)
          .sort((a, b) => (a.id < b.id) ? 1 : -1)
          .map((group) => group.name).join('/'),
        deleteFlg: item.deleteFlg ?? false,
        admin: item.admin ?? false
      },
      style: 'sm:whitespace-normal'
    }
  });

  const selectNumberList =
    [
      { id: 50, name: "50" },
      { id: 100, name: "100" },
      { id: 200, name: "200" },
    ];

  // 運営者数の表示
  const getMessage = async () => {
    // 契約者数を取得
    const company = await companiesQuery.getCompany(currentUser?.tenantId!); 
    setUserCount(company.usersCount);

    // 運営者数を取得
    const adminCount = await companiesQuery.getAdminUserCount(currentUser?.tenantId!); 
    setAdminUserCount(adminCount);
  }

  // 検索時と表示件数変更時に1ページ目を表示する
  useEffect(() => {
    setFirstPageFlg(true)
  }, [searchUserListFlg, searchUserList, selectNumber])

  return (
    <div className="h-full">
      <div className="sm:flex sm:items-center px-6 pt-6 pb-4">
        <div className="flex items-center gap-6">
          <h2 className="min-w-[100px] min-h-[28px] text-xl font-semibold text-gray-900">
            利用者一覧
          </h2>
          <div className="min-w-fit flex gap-3">
            <h3 className="mr-1">アプリ利用</h3>
            <h3 className="">利用可：{appAvailableUserCnt}</h3>
            <h3 className="">不可：{AppUnavailableUserCnt}</h3>
          </div>
          <h3 className="min-w-fit">/</h3>
          <div className="min-w-fit flex gap-3 items-center">
            <h3 className="mr-1">役割</h3>
            <h3 className="flex items-center">運営者：
              <span className="text-xl font-semibold" style={{color:userCount*0.2 < adminUserCount? 'red':'text-gray-900', fontWeight:userCount*0.2 < adminUserCount?'bold':'normal'}}>{adminUserCount}</span>
            </h3>
          </div>
          <h3 className="text-sm text-gray-500">運営者数が契約数の20％({Math.floor(userCount*0.2)}件)を超えた場合は赤字で表示されます</h3>
        </div>
      </div>
      <div>
        </div>
        <>
          <div className={"px-6 pb-3"}>
            <UserListSearch
              userList={userList}
              setSearchUserList={setSearchUserList}
              setSearchUserListFlg={setSearchUserListFlg}
              groupList={groupList}
              searchKey1List={searchKey1List}
              searchKey2List={searchKey2List}
              searchKey3List={searchKey3List}
              companyData={company}
              setIsUpdateSearchKeys={setIsUpdateSearchKeys}
              onSearch={handleSearch}
              searchCondition={searchCondition}
            />
          </div>
          {isLode === true ? <Spiner/> : ( 
            <div className={'px-6 pb-6'}>
              <TableList
                header
                gridCol={columns}
                gridRow={rowList}
                limit={selectNumber}
                selectNumberList={selectNumberList}
                setSelectNumber={setSelectNumber}
                gridRowLength={totalCount}
                firstPageFlg={firstPageFlg}
                setFirstPageFlg={setFirstPageFlg}
                pagingFunc={pagingFunc}
              />
            </div>
          )}
        </>
    </div>
  );
};
